import Module from '../module';
import scroll from '../../libs/scroll/scroll';

interface OptionsInterface {
	cssId: {
		anim?: {
			homeVideoVideoContentId: string;
		}
	},

	slug: string
}

class Video extends Module {

	publicVars: OptionsInterface;

	constructor(options: OptionsInterface) {
		super('Home Video Module');

		this.publicVars = options;
	}

	startup() {
		this.msg('startup');

		scroll.init();
		scroll.registerAnimatedElement(this.publicVars.cssId.anim?.homeVideoVideoContentId || '', 'home_video', { animCls: 'animate__zoomIn50P', once: true});
	}

	bind() {
		this.msg('bind');
	}
}

export default Video;